import { useEffect } from "react"

import { Form } from "@/components/forms/Form"
import { RadioField } from "@/components/forms/RadioField"
import { TextField } from "@/components/forms/TextField"
import { Textarea } from "@/components/forms/Textarea"
import type { LicenseData } from "@/hooks/useLicenseStore"
import { useStrings } from "@/hooks/useStrings"
import type { UseFormReturn } from "react-hook-form"
import { ChoiceField } from "@/components/forms/ChoiceField"

type LicenseDurationProps = {
  form: UseFormReturn<LicenseData>
}

export const LicenseDuration = ({ form }: LicenseDurationProps) => {
  const strings = useStrings()
  const hasExpiry = form.watch("hasExpiry")
  const options = [strings.option.no, strings.option.yes].filter(Boolean) as string[]
  const expiryEnabled = hasExpiry === strings.option.yes

  useEffect(() => {
    if (!expiryEnabled) {
      form.resetField("expiryDate")
      form.resetField("expiryActions")
    }
  }, [expiryEnabled, form])

  return (
    <Form form={form}>
      <div className="space-y-5">
        <RadioField
          form={form}
          name="hasExpiry"
          description={strings.question.expiryDate}
          options={options}
          layout="inline"
          defaultValue={strings.option.no}
        />
        {expiryEnabled ? (
          <div className="space-y-5">
            <div className="max-w-[240px]">
              <TextField
                form={form}
                name="expiryDate"
                label={strings.title.expiryDate}
                inputProps={{ type: "date" }}
              />
            </div>
            <Textarea
              form={form}
              name="expiryActions"
              label={strings.title.expiryActions}
              description={strings.question.expiryActions}
              textareaProps={{ rows: 4 }}
            />
          </div>
        ) : null}
      </div>
    </Form>
  )
}
